let backendHost;

const hostname = window && window.location && window.location.hostname;

if (hostname === "localhost") {
    backendHost = "https://localhost:44362";
}
else {
    backendHost = process.env.REACT_APP_BACKEND_HOST || 'http://localhost:50011';
}
export const API_ROOT = `${backendHost}`;



// WEBPACK FOOTER //
// ./src/services/apiConfig.js